var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customer-current-info loader-container"},[_c('h2',[_vm._v("Current Info")]),_c('div',{staticClass:"table-wrapper loader-container"},[_c('vue-good-table',{attrs:{"columns":[
        {
          label: 'Name',
          field: 'infoName'
        },
        {
          label: 'Value',
          field: 'infoValue'
        }
      ],"rows":_vm.customerCurrentInfo}}),_c('Loader',{attrs:{"loading":_vm.loadingCustomerCurrentInfo}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }